import MaterialPagination, {
    PaginationProps,
} from '@mui/material/Pagination';

export function Pagination(props: PaginationProps) {
    return (
        <MaterialPagination data-testid={'Pagination-container'} {...props} />
    );
}

export default Pagination;
